import React from 'react';
import styled from 'styled-components';
import {
  brandColours,
  minBreakpointQuery,
  maxBreakpointQuery,
  standardColours,
} from '../styles';
import CaseStudyCard from './CaseStudyCard';

const StyledCaseStudyList = styled.div`
  display: grid;
  gap: 30px;

  ${minBreakpointQuery.small`
    gap: 35px;
  `}

  ${minBreakpointQuery.smedium`
    grid-template-columns: repeat(2, 1fr);
  `}

  ${minBreakpointQuery.medium`
    gap: 40px;
  `}

  ${minBreakpointQuery.large`
    gap: 45px;
  `}

  ${minBreakpointQuery.xxlarge`
    gap: 50px;
  `}
`;

const StyledItem = styled(CaseStudyCard)`
  border: solid 1px ${standardColours.lighterGrey};

  ${maxBreakpointQuery.smedium`
    &:nth-child(even) {
      background-color: ${brandColours.primary};
    }

    &:nth-child(odd) {
      background-color: ${standardColours.white};
    }
  `}

  ${minBreakpointQuery.smedium`
    &:nth-child(4n + 1),
    &:nth-child(4n + 4) {
      background-color: ${standardColours.white};
    }

    &:nth-child(4n + 2),
    &:nth-child(4n + 3) {
      background-color: ${brandColours.primary};

    }
  `}
`;

const CaseStudyList = ({ items }) => (
  <StyledCaseStudyList>
    {items.map((item, id) => (
      <StyledItem key={id} {...item} />
    ))}
  </StyledCaseStudyList>
);

export default CaseStudyList;
